import React, { useEffect, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import DateTimeRangePicker, { Ranges } from '../../components/dateTimePicker/DateTimeRangePicker';
import { DateTimePickerFormGroup } from '../../components/dateTimePicker/DateTimePickerCommon';
import { PageContext } from '../components/page';
import ButtonDefault from '../../components/forms/Buttons';
import FullPageLoadingSpinner from '../components/fullPageLoadingSpinner';
import PageContentWrapper from '../components/pageContentWrapper';
import { DoGetTripsMonitoredReportProps } from './TripsMonitoredReportContainer';

const BodyCard = styled.div`
  background-color: #7a8794;
  color: #ffffff;
  padding: 10px;
`;

interface TripsMonitoredReportProps {
  onSubmit: (props: DoGetTripsMonitoredReportProps) => void;
}

const TripsMonitoredReport: React.FC<TripsMonitoredReportProps> = ({ onSubmit }) => {
  const { pushAlert } = React.useContext(PageContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [awaitingDownload, setAwaitingDownload] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(6, 'd'),
    endDate: moment(),
  });

  useEffect(() => {
    const initialLoadTimer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(initialLoadTimer);
  }, []);

  const handleFetchError = (message: string) => {
    pushAlert('danger', message);
  };

  const handleSubmit = () => {
    setAwaitingDownload(true);
    onSubmit({
      dateRange,
      handleFetchError,
      callback: () => {
        setAwaitingDownload(false);
      },
    });
  };

  const ranges: Ranges = {
    Today: [moment().startOf('day'), moment().endOf('day')],
    Yesterday: [
      moment().subtract(1, 'day').startOf('day'),
      moment().subtract(1, 'day').endOf('day'),
    ],
    'Last Week': [
      moment().subtract(1, 'week').startOf('week').startOf('day'),
      moment().subtract(1, 'week').endOf('week').endOf('day'),
    ],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month').startOf('day'),
      moment().subtract(1, 'month').endOf('month').endOf('day'),
    ],
    'Last 30 Days': [
      moment().subtract(29, 'days').startOf('day'),
      moment().endOf('day'),
    ],
  };

  return (
    <>
      {awaitingDownload && <FullPageLoadingSpinner />}
      {loading && <FullPageLoadingSpinner />} {/* Conditionally render the spinner */}
      <PageContentWrapper title={'TRIPS MONITORED REPORT'}>
        <BodyCard>
          <p>
            This reporting tool gives you the ability to view the number of
            trips that were monitored and/or received messaging for your account
            over a given time period.
          </p>
          <form>
            <DateTimePickerFormGroup label="Date Range:" labelPosition="left">
              <div className="col-sm-6 col-md-3 col-lg-3">
                <DateTimeRangePicker
                  name="dateRange"
                  onChange={(newDateRange: { startDate: moment.MomentInput; endDate: moment.MomentInput }) => {
                    setDateRange({
                      startDate: moment(newDateRange.startDate),
                      endDate: moment(newDateRange.endDate),
                    });
                  }}
                  className="date-range-picker-input"
                  value={dateRange}
                  ranges={ranges}
                />
              </div>
            </DateTimePickerFormGroup>
            <ButtonDefault
              id="downloadButton"
              className="btn btn-default button-action"
              type="button"
              onClick={handleSubmit}
            >
              DOWNLOAD
            </ButtonDefault>
          </form>
        </BodyCard>
      </PageContentWrapper>
    </>
  );
};

export default TripsMonitoredReport;